const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff         : string = "/api";
export const StoreQuery: any = {
    GetStoreSaleOrderByOrderNoV2: Backofficebff + '/v2/store/sale-orders/by-orderno',
    GetStoreInvoiceFile: Backofficebff + '/v1/store/invoice-file',
    GetDocumentHeaderOfInvoiceByOrderId: Backofficebff + '/v1/store/getdocumentheaderofinvoicebyorderid',
    GetMPReturnCargoLabel: Backofficebff + '/v1/store/getmpreturncargolabel',
    GetStoreDispatchFileForReturn: Backofficebff + '/v1/store/dispatch-file-for-return',
    GetCargoLabelPdf: Backofficebff + '/v1/store/getcargolabelpdf',
};
